// @ts-nocheck
import isElement from 'lodash/isElement';
import { getParentNode, getScrollParent } from './utils';
export function getAppendToElement(appendTo, node) {
  if (!appendTo) {
    return null;
  }
  if (typeof appendTo === 'string') {
    switch (appendTo) {
      case 'window':
      case 'viewport':
        return document.body;
      case 'scrollParent':
        return getScrollParent(node);
      default:
        return;
    }
  }
  if (typeof appendTo === 'function') {
    return getByPredicate(appendTo, node);
  }
  if (isElement(appendTo)) {
    return appendTo;
  }
  return;
}
function getByPredicate(predicate, element) {
  if (!element) {
    return;
  }
  const node = searchParent(predicate, element);
  if (node) {
    return node;
  }
  return;
}
function searchParent(predicate, element) {
  if (!element) {
    return;
  }
  if (predicate(element)) {
    return element;
  }
  return searchParent(predicate, getParentNode(element));
}
//# sourceMappingURL=getAppendToElement.js.map